import React from "react";

import Button from "../../../Components/Button";
import CommonModal from "../../../Components/Modal";
import "./style.scss";

interface ToggleRlAssessmentsModalProps {
  isOpen: boolean;
  toggle: () => void;
  organizationName: string;
  isEnabling: boolean;
  onConfirm: () => void;
  loading?: boolean;
  nested?: boolean;
}

const ToggleRlAssessmentsModal: React.FC<ToggleRlAssessmentsModalProps> = ({
  isOpen,
  toggle,
  organizationName,
  isEnabling,
  onConfirm,
  loading = false,
  nested = false,
}) => {
  const title = isEnabling
    ? "Enable Relationship Assessments"
    : "Disable Relationship Assessments";
  const action = isEnabling ? "enable" : "disable";

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      size="md"
      nested={nested}
    >
      <div className="toggle-rl-assessments-modal">
        <p className="confirmation-text">
          Are you sure you want to {action} relationship assessments for{" "}
          <strong>{organizationName || "this organization"}</strong>?
        </p>

        <div className="modal-actions">
          <Button variant="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            loading={loading}
            variant={isEnabling ? "primary" : "danger"}
            onClick={onConfirm}
          >
            {isEnabling ? "Enable" : "Disable"}
          </Button>
        </div>
      </div>
    </CommonModal>
  );
};

export default ToggleRlAssessmentsModal;
